//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { OpDescr } from './index'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { TypeHelper } from '../../helpers';

export class OpSlotType
    implements IReferenceType, IOpChangeState, IJsonSerializable
{
    // Properties

    public idSlotType: number
    public name: string
    public idDescr: number

    // Properties End

    // Navigation Properties

    public descr: OpDescr

    // Navigation Properties End

    // Custom Properties



    // Custom Properties End

    // Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor End

    // IReferenceType

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdSlotType
    }
    public getReferenceKey(): number {
        return this.idSlotType
    }
    public getReferenceValue(): any {
        return this
    }

    // IReferenceType End

    // IOpChangeState

    public opState: Enums.OpChangeState

    // IOpChangeState End

    // IJsonSerializable

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idSlotType = opObj.ID_SLOT_TYPE
            this.name = opObj.NAME
            this.idDescr = opObj.ID_DESCR

            this.opState = opObj.OpState

            this.descr = opObj.Descr != null ? new OpDescr(opObj.Descr) : null
        }
    }
    public toJSON(compressed: boolean = false): any {
        return {
            ID_SLOT_TYPE: this.idSlotType,
            NAME: this.name,
            ID_DESCR: this.idDescr,

            OpState: this.opState
        }
    }

    // IJsonSerializable End

    public toString(): string {
        let str: string = this.descr
            ? this.descr.toString()
            : null

        if (TypeHelper.isNullOrEmpty(str)) {
            str = this.name
        }

        return str
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpSlotType[]): JQueryPromise<OpSlotType[]> {
        const defered: JQueryDeferred<OpSlotType[]> = $.Deferred<OpSlotType[]>()

        defered.resolve(list)

        return defered.promise()
    }
}
